// @ts-ignore
import Colors from '../scss/riseup-js-colors.module.scss';

export default {
  grey: {
    number: Colors.riseupGray2,
    unfilledBar: Colors.riseupGray0,
    filledBar: Colors.riseupGray1,
    exclamationMark: 'exclamation-mark-gray.svg',
  },
  blue: {
    number: Colors.riseupBlue,
    unfilledBar: Colors.riseupLightBlue,
    filledBar: Colors.riseupBlue,
    exclamationMark: 'exclamation-mark-blue.svg',
  },
  yellow: {
    number: Colors.riseupYellow,
    unfilledBar: Colors.riseupLightYellow,
    filledBar: Colors.riseupYellow,
    exclamationMark: 'exclamation-mark-yellow.svg',
  },
  pink: {
    number: Colors.riseupRed,
    unfilledBar: Colors.riseupLightRed,
    filledBar: Colors.riseupRed,
    exclamationMark: 'exclamation-mark-red.svg',
  },
  green: {
    number: Colors.riseupGreen,
    unfilledBar: Colors.riseupLightGreen,
    filledBar: Colors.riseupGreen,
    exclamationMark: 'exclamation-mark-green.svg',
  },
  orange: {
    number: Colors.riseupOrange,
    unfilledBar: Colors.riseupLightOrange,
    filledBar: Colors.riseupOrange,
    exclamationMark: 'exclamation-mark-coral.svg',
  },
};
